import { minutesToMs, socialApi, UsePopularPartnersKey } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

export const usePopularPartners = () => {
	return useQuery({
		queryFn: async () => (await socialApi).fetchSocialPopularPartners({ limit: 10 }),
		queryKey: UsePopularPartnersKey,
		select: resp =>
			resp.data.map(partner => ({
				logo: partner.images.find(image => image.imageType?.type === 'partner_logo') || partner.images[0],
				...partner
			})),
		staleTime: minutesToMs(5)
	});
};
